module.exports = __webpack_public_path__ + "static/img/kaishihuiyi2.385088e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/kaishihuiyi2.png
// module id = 0B5N
// module chunks = 24